// **********************************************************
//  specialisations-slider
// **********************************************************
/* eslint-disable */
$(function () {

  function numberCounter(scrol_position_bottom) {
    $('.count').each(function () {
      if ($(this).offset().top + 50 <= scrol_position_bottom) {
        $(this).removeClass('count');
        var endValue = $(this).data('count').toString().replace('.', '').replace(',', '.');
        var addPercent = '';
        if (~endValue.indexOf('%')) {
          endValue = endValue.replace('%', '');
          addPercent = '%';
        }

        $(this)
          .prop('Counter', 0)
          .animate({
            Counter: $(this).data('count').toString().replace('.', '').replace(',', '.')
          }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
              var num = Math.round(now).toString();
              if (endValue % 1 != 0) {
                num = now.toFixed(1).toString();
              }

              if (Number(num) > 999) {
                num = num.replace('.', ',');
                while (/(\d+)(\d{3})/.test(num)) {
                  num = num.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                }
              } else if (endValue % 1 != 0) {
                num = num.replace('.', ',');
              }

              $(this).text(num + addPercent);
            }
          });
      }
    });
  }

  // ***
  // SCROLL
  // ***
  if ($('.count').length) {
    $(window).scroll(function () {
      numberCounter($(this).scrollTop() + $(this).height());
    });
  }

});
/* eslint-enable */
